import { Sparkles } from "lucide-react";
import { Button } from "@/shared/components/ui/button";
import { useAssistantUi } from "./assistant-ui-context";

/** The "Ask" button (Topbar) that opens the assistant panel. */
export function AssistantLauncher() {
  const { openPanel } = useAssistantUi();
  return (
    <Button variant="outline" size="sm" data-testid="assistant-launch" onClick={openPanel}>
      <Sparkles className="h-[14px] w-[14px]" strokeWidth={2.2} />
      Ask
      <kbd className="ml-1 hidden rounded border border-ge-border-card px-1 font-mono text-[10px] text-ge-faint sm:inline">
        ⌘K
      </kbd>
    </Button>
  );
}
